/* eslint-disable */
import axios from "axios";
import { IGalleryPhoto } from "../../types/types";

export const updateServiceNameOnGallery = (
  gallery: IGalleryPhoto[],
  oldServiceName: string,
  newServiceName: string
) => {
  return gallery.map((photo) => {
    const updatedServices = photo.services.map((service) => {
      if (service.name === oldServiceName) {
        return { ...service, name: newServiceName };
      }
      return service;
    });
    return { ...photo, services: updatedServices };
  });
};

export const getOrderedServicePhotos = (
  gallery: IGalleryPhoto[],
  serviceName: string
): IGalleryPhoto[] => {
  return (
    gallery
      ?.filter((galleryPhoto) => {
        return galleryPhoto.services.find(
          (service) => service.name === serviceName
        );
      })
      .sort(
        (a, b) =>
          a.services.find((service) => service.name === serviceName)!.order -
          b.services.find((service) => service.name === serviceName)!.order
      ) || []
  );
};

export const getMaxServicePhotosOrder = (
  gallery: IGalleryPhoto[],
  serviceName: string
): number => {
  return gallery.reduce((max, photo) => {
    const photoOrder =
      photo.services.find((service) => service.name === serviceName)?.order ??
      0;
    return Math.max(max, photoOrder);
  }, 0);
};

export function getArrayofThreeRandomPhoto(gallery: any) {
  if (!gallery) return [];
  if (gallery.length === 0) return [];
  let randomPhotoArr: any = [];
  const newGallery = [...gallery];
  for (let i = 0; i < 3; i++) {
    const randomNum = Math.floor(Math.random() * newGallery.length);
    const randPhoto = newGallery[randomNum];
    randomPhotoArr = [...randomPhotoArr, { ...randPhoto, stock: false }];

    // delete photo in newGallery to avoid duplicate photo
    newGallery.splice(randomNum, 1);

    // in case gallery has less than 3 photos for all photos
    if (newGallery.length === 0) break;
  }
  console.log("about to return ", randomPhotoArr);
  return randomPhotoArr;
}

export async function getServiceKeywordFamilies(
  serviceName: string,
  industry: string
): Promise<{ primary_keyword: string; keywords: string[] }[]> {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/seo/default-keyword-families/search`,
      {
        params: { industry, service: serviceName },
      }
    );
    return response.data.message;
  } catch (e) {
    console.log(e);
    return [];
  }
}
